/* eslint-disable no-unused-vars */
import { createContext } from 'react';

interface IContextProps {
  onTabChange: (event: React.SyntheticEvent<Element, Event>, value: any) => void;
  onClose: () => void;
}

export default createContext<IContextProps | null>(null);
